// The system roles of the shared RBAC (Gasbi.Rbac.Shared Roles), the same ids on every RBAC host. The roles pages
// manage BMS's roles, which are on the shared RBAC since GSB-8317, so the legacy RootRoleId of
// @gasbi/shared/common/features/roles does not apply.
export enum RootRoleId {
  Administrator = '019e8cdd-0a85-7efd-9985-6b10c14fceb0',
  Manager = '019e8cdd-0a85-7a74-bc70-f6a6c8ec66f7',
  User = '019e8cdd-0a85-7adc-9541-2507d2182041',
}

export enum RoleType {
  Administrator = 'administrator',
  Manager = 'manager',
  User = 'user',
  Custom = 'custom',
}
